import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import CircleProgress from "../components/CircleProgress";
import DateRangeFilterRTL from "../components/DateRangeFilterRTL";
import TotalReviewsCard from "../components/TotalReviewsCard";
import { CONSTANTS } from "../constants";
import Layout from "../layouts/layout";
import { getRating, getRatingIcon, toast } from "../utils/utils";
const Home = () => {
  const [loading, showLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);

  const [totalReviews, setTotalReviews] = useState(0);
  const [totalHappy, setTotalHappy] = useState(0);
  const [totalConfused, setTotalConfused] = useState(0);
  const [totalSad, setTotalSad] = useState(0);
  const [dateRange, setDateRange] = useState({
    startDate: new Date().setDate(new Date().getDate() - 30),
    endDate: new Date(),
  });

  const customStyles = {
    rows: {
      style: {
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        backgroundColor: "#F6F3EE",
      },
    },
    cells: {
      style: {
        borderBottom: "1px solid #E9EAEC",
        whiteSpace: "wrap",
      },
    },
  };
  const conditionalRowStyles = [
    {
      when: () => true,
      style: {
        backgroundColor: "#ffffff",
        "&:nth-of-type(even)": {
          backgroundColor: "#F9F9F",
        },
      },
    },
  ];

  const columns = [
    {
      name: t("Id"),
      sortable: false,
      width: "10%",

      selector: (row) => row.id,
    },
    {
      name: t("Customer"),
      selector: (row) => row.customer,
      width: "25%",
      wrap: true,
    },
    // {
    //   name: t("Contact"),
    //   selector: (row) => row.contactNo,
    //   width: "20%",
    //   wrap: true,
    // },
    {
      name: t("Date"),
      selector: (row) => row.date ? moment(row.date).format("DD-MM-YYYY") : "-",
      width: "10%",
    },
    {
      name: t("Ratings"),
      selector: (row) => (
        <img src={getRatingIcon(row.rating)} height={20} width={20} alt="" />
      ),
      width: "10%",
    },
    {
      name: t("Comments"),
      selector: (row) => row.comments,
      width: "45%",
      wrap: true,
    },
  ];

  const calculateAllPercentage = useCallback((data) => {
    // Filter out null/undefined values
    const validData = data.filter((obj) => obj.question3 != null);

    if (validData.length === 0) {
      console.log('No valid data for percentage calculation');
      return;
    }

    // Step 1: Count occurrences of each name
    const nameCounts = validData.reduce((acc, obj) => {
      acc[obj.question3] = (acc[obj.question3] || 0) + 1;
      return acc;
    }, {});

    console.log(nameCounts);
    // Step 2: Calculate total number of valid objects
    const totalCountAll = validData.length;

    // Step 3: Calculate percentage for each unique name
    const namePercentages = Object.keys(nameCounts).map((name) => {
      return {
        name: name,
        percentage: ((nameCounts[name] / totalCountAll) * 100).toFixed(2) + "%",
      };
    });

    console.log('namePercentages', namePercentages);
  }, []);

  const setChartData = useCallback((data) => {
    // Filter out null/undefined values
    const validData = data.filter((item) => item.question3 != null);

    const confusedCount = validData.filter((i) => i.question3 === "Neutral").length;
    const sadCount = validData.filter((i) => i.question3 === "Frustrated").length;
    const happyCount = validData.filter((i) => i.question3 === "Happy").length;

    console.log(confusedCount);
    console.log(sadCount);
    console.log(happyCount);
    const totalCount = happyCount + sadCount + confusedCount;
    const uniqueStatus = [...new Set(validData.map((item) => item.question3))];
    console.log(uniqueStatus);
    const happyPercentage =
      totalCount > 0 ? ((happyCount / totalCount) * 100).toFixed(2) : 0;
    const sadPercentage =
      totalCount > 0 ? ((sadCount / totalCount) * 100).toFixed(2) : 0;
    const confusedPercentage =
      totalCount > 0 ? ((confusedCount / totalCount) * 100).toFixed(2) : 0;
    setTotalHappy(happyPercentage);
    setTotalConfused(confusedPercentage);
    setTotalSad(sadPercentage);
  }, []);

  const getDataForDashboard = useCallback((range = null) => {
    showLoading(true);
    const token = window.localStorage.getItem("access_token");
    const currentRange = range || dateRange;
    let url = CONSTANTS.DashboardData;
    if (currentRange.startDate) {
      url =
        url +
        "?from=" +
        moment(currentRange.startDate).format("YYYY/MM/DD") +
        "&to=" +
        moment(currentRange.endDate).format("YYYY/MM/DD");
    }
    fetch(url, {
      headers: {
        Token: `${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        showLoading(false);
        console.log(json);
        if (json.code === 200) {
          setTotalReviews(json?.data.length);
          setChartData(json?.data);
          calculateAllPercentage(json?.data);

          const mapData = json?.data.map((reg, i) => {
            return {
              id: i + 1,
              customer: reg.fullName,
              contactNo: reg.email,
              date: reg.submittedOn,
              rating: getRating(reg.question3),
              comments: reg.question4,
              feedBack: reg.feedBack,
              createdDate: reg.requestedOn,
            };
          });
          setRequests(mapData);
        } else if (json.status === 400) {
          toast(
            "Error",
            "Failed to fetch the data. Please try again",
            "Ok",
            "error"
          );
        } else {
          if (json.status === 404) {
            window.localStorage.removeItem("access_token");
            window.localStorage.removeItem("access_token");
            navigate("/");
            return;
          }
          toast(
            "Error",
            json.message || "Failed to fetch the data. Please try again",
            "Ok",
            "error"
          );
        }
      })
      .catch((e) => { });
  }, [calculateAllPercentage, dateRange, navigate, setChartData]);

  const handleDateChange = (range) => {
    setDateRange(range);
    getDataForDashboard(range);
    console.log("Selected Date Range:", range);
  };

  useEffect(() => {
    if (requests.length === 0) {
      getDataForDashboard();
    }
  }, [getDataForDashboard, requests.length]);

  return (
    <>
      <Layout>
        <main
          className={`flex min-h-screen flex-col gap-5 items-center  justify-start `}
        >
          <div className="flex flex-col bg-white p-4 w-full">
            <div className="flex w-full justify-between  py-2">
              <h4 className=" font-semibold text-xl text-black">
                {t("overview")}
              </h4>
              <DateRangeFilterRTL
                onDateChange={handleDateChange}
                startDateInit={dateRange.startDate}
                endDateInit={dateRange.endDate}
              />
            </div>
            {(
              <div className=" ">
                <div className="flex flex-row gap-5 justify-between">
                  <TotalReviewsCard loading={loading} count={totalReviews} />
                  {/* <TotalCommentsCard count={totalComments} /> */}

                  <div className="bg-white rounded-lg shadow p-4">
                    <h2 className="text-xl text-black font-semibold text-start">
                      {t("OverallHappinessData")}
                    </h2>
                    <div className="flex justify-center items-center">
                      <CircleProgress
                        percentage={totalHappy}
                        sColor={"#FFD93B"}
                        emoji={"./assets/img/happy.png"}
                        loading={loading}
                        title={t("VeryHappy")}
                      />
                      <CircleProgress
                        percentage={totalConfused}
                        sColor={"#B0B0B0"}
                        emoji={"./assets/img/confused.png"}
                        loading={loading}
                        title={t("Happy")}
                      />
                      <CircleProgress
                        percentage={totalSad}
                        sColor={"#FF3C4E"}
                        title={t("Netural")}
                        loading={loading}
                        emoji={"./assets/img/sad.png"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

          
          </div>

          <div className="flex flex-row w-full bg-white  ">
            <div className="flex flex-col flex-1 p-5 gap-5 rounded-lg shadow-md w-full max-w-screen bg-white">
              <div className="flex flex-row text-black justify-between  max-w-screen pt-4 items-start">
                <h1 className="text-black text-2xl font-medium">
                  {t("Requestwaitingforreply")}
                </h1>
                <div className="flex flex-row gap-5 items-center">
                  <a
                    className=" font-medium text-md rounded-3xl px-5 bg-[#F0F0F0] py-3 text-neutral-700"
                    href="/feedbacks"
                  >
                    {t("Viewall")}
                  </a>
                </div>
              </div>
              <div className=" max-w-screen overflow-x-auto  w-full">
                {requests.length > 0 && (
                  <DataTable
                    columns={columns}
                    data={requests}
                    labelRowsPerPage={""}
                    paginationComponentOptions={{ noRowsPerPage: true }}
                    // onRowClicked={handleRowClick}
                    customStyles={customStyles}
                    highlightOnHover
                    conditionalRowStyles={conditionalRowStyles}
                    pagination
                    pointerOnHover
                  ></DataTable>
                )}
              </div>
            </div>
          </div>
        </main>
      </Layout>
    </>
  );
};

export default Home;
